<template>
  <v-content>
    <v-layout>
      <NavbarRegistration />

      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <LandingRegistrationStepField />
        </v-layout>
      </v-container>
    </v-layout>
  </v-content>
</template>

<script>
import LandingRegistrationStepField from '@/components/LandingRegistrationStepField';
import NavbarRegistration from '@/views/NavbarRegistration';

export default {
  components: {
    LandingRegistrationStepField,
    NavbarRegistration
  },
  methods: {},
  computed: {}
};
</script>
